/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AuscultatoryCardiacExamStatus {
    NO_MODIFICATIONS = 'noModifications',
    HEART_MURMURS = 'heartMurmurs',
    ARRHYTHMIA = 'arrhythmia',
    OTHER_MODIFICATIONS = 'otherModifications',
}
